// Copyright (c) Move Closer 2022.

import { Component, Vue } from 'vue-property-decorator'
import { EventbusType, IEventbus, IModal, ModalType } from '@movecloser/front-core'

import { Inject } from '../../../support'

import { IPrivacyManager, IPrivacyManagerType } from '../services'
import { Modals } from '../config/modals'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
@Component<InitPrivacyMixin>({
  name: 'InitPrivacyMixin',
  mounted () {
    this.openPreferencesModal()
    this.updateAnalytics()
  }
})
export class InitPrivacyMixin extends Vue {
  @Inject(EventbusType)
  protected readonly eventBus!: IEventbus

  @Inject(ModalType)
  protected readonly modalConnector!: IModal

  @Inject(IPrivacyManagerType)
  public readonly privacyService!: IPrivacyManager

  /**
   * Open Privacy Modal
   */
  private openPreferencesModal (): void {
    if (this.privacyService.hasAllPreferencesSet() || !this.privacyService.isEnabled) {
      return
    }

    this.modalConnector.open(Modals.PrivacyModal, {}, { closeOnClickOutside: false })
  }

  private updateAnalytics (): void {
    this.eventBus.emit('app:consents.update', this.privacyService.getPreferences())
  }
}
